
import './Contact-sec1.css';
import Footer from '../Components/footer.js';
import email from './img/email.png';
import mobile from './img/phone.png';
import Map from './map.js';
import React, { useState } from 'react';
import Callbtn from '../Components/callbtn.js';

const ContactSec1 = () => {
  
  const [name, setName] = useState("");
  const [emailVal, setEmailVal] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [subjectVal, setSubjectVal] = useState("");
  const [messageVal, setMessageVal] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const text = encodeURIComponent(
      `Name: ${name}
Email: ${emailVal}
Mobile: ${mobileNo}
Subject: ${subjectVal}
Message: ${messageVal}`
    );

    const url = `https://wa.me/91 81780 67868?text=${text}`;
    window.open(url, "_blank");
  };

  return (
    <div className= 'contact-sec1'>
      <div className='contact-box'>
        <div className='contact-box-top'>
        <h2>Contact Us</h2>
       <p>Protect your digital future with trusted cybersecurity support. Reach out today.</p>
        <div className='line'></div>
        <div className='call-btn'>
          <Callbtn/>
          </div>
        </div>
<div className='contact-container'>
  <div className='contact-left'>
    <h1>Get in Touch</h1>
    <p>Get in touch with our trusted team for inquiries, expert guidance, or career opportunities in cybersecurity.</p>
    <div className='email'>
      <img src={email} alt="Email" />
<div className='email-content'>
    <h3>Email Us</h3>
    <div className='text'>
    <p>General :</p>
<h4>csl260399@gmail.com</h4>
</div>
</div>
</div>
  <div className='mobile'>
      <img src={mobile} alt="mobile" />
<div className='mobile-content'>
    <h3> Contact Number</h3>
    <div className='text'>
    <p>General :</p>
<h4>+91 95607 93335</h4>
</div>
</div>
</div>
  </div>
   <div className='contact-right'>
  <h2>Send Message</h2>

  <form className="contact-form" onSubmit={handleSubmit}>

    <input type="text" placeholder="Name" className="input"
      onChange={(e) => setName(e.target.value)} />

    <input type="email" placeholder="Email ID" className="input"
      onChange={(e) => setEmailVal(e.target.value)} />

    <input type="text" placeholder="Mobile No." className="input"
      onChange={(e) => setMobileNo(e.target.value)} />

    <input type="text" placeholder="Course" className="input"
      onChange={(e) => setSubjectVal(e.target.value)} />

    <textarea placeholder="Message" className="textarea"
      onChange={(e) => setMessageVal(e.target.value)}></textarea>

    <button type="submit" className="btn">
      Start Your Cyber Career
    </button>

  </form>
</div>
  </div>
<div className='location'>
  <h1>Our Location</h1>
  <p>Find us here—trusted cybersecurity experts dedicated to your digital safety.</p>
</div>
<div className='map'>
{/* <Map/> */}

</div>
<div>
  <Footer/>
</div>

      </div>
    </div>
  )
}

export default ContactSec1   


